export const GET_PROJECT_DETAIL = 'GET_PROPERTY_DETAIL';
export const GET_RES_FEATURED_PROJECTS = 'GET_RES_FEATURED_PROJECTS';
export const GET_COMM_FEATURED_PROJECTS = 'GET_COMM_FEATURED_PROJECTS';
export const GET_FEATURED_PROJECTS_WITH_PAGINATION = 'GET_FEATURED_PROJECTS_WITH_PAGINATION';
export const GET_PROJECT_TYPES = 'GET_PROJECT_TYPES';
export const GET_PROJECTS_WITH_PAGINATION = 'GET_PROJECTS_WITH_PAGINATION';
